import { Skill, SkillApiResponse } from '@/apis/skills/types/skillsApi';
import { PaginatedResponse, PaginatedResponseFromApi } from '@/types';

export const skillFromApiAdapter = (site: SkillApiResponse): Skill => {
  return {
    empId: site.EmpID,
    certDate: site.CertDate,
    expirationDate: site.ExpirationDate,
    certId: site.CertID,
    proficiency: site.Proficiency ?? null,
    name: site.Name ?? null,
    skill: site.Skill ?? null,
    notes: site.Notes ?? null,
    country: site.Country ?? null,
  };
};

export const millwrightSkillsFromApiAdapter = (
  response: PaginatedResponseFromApi<SkillApiResponse>,
): PaginatedResponse<Skill> => {
  return {
    results: response?.results.map(skillFromApiAdapter) ?? [],
    total: response.total,
    limit: response.limit,
    offset: response.offset,
    nextOffset: response.next_offset,
    prevOffset: response.prev_offset,
  };
};
